export default __webpack_public_path__ + "static/media/FilmAvater.60f3d889.jpg";